import { BrowserRouter, Route, Routes } from "react-router-dom";
import HomePageSix from "./pages/HomePageSix";
import EmailPage from "./pages/EmailPage";
import AddUserPage from "./pages/AddUserPage";
import CalendarMainPage from "./pages/CalendarMainPage";
import ChatMessagePage from "./pages/ChatMessagePage";
import CompanyPage from "./pages/CompanyPage";
import CurrenciesPage from "./pages/CurrenciesPage";
import ErrorPage from "./pages/ErrorPage";
import ExamPage from "./pages/ExamPage";
import AllExamsPage from "./pages/AllExamsPage";
import ExamResultsPage from "./pages/ExamResultsPage"; // Added for exam results
import ExamResultDetailsPage from "./pages/ExamResultDetailsPage"; // Added for exam result details
import AddCategoriesPage from "./pages/AddCategoriesPage";
import QuestionsPage from "./pages/QuestionsPage";
import ResultsPage from "./pages/ResultsPage";
import PracticeMCQsPage from "./pages/PracticeMCQsPage";
import QuizMCQsPage from "./pages/QuizMCQsPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import InvoiceAddPage from "./pages/InvoiceAddPage";
import InvoiceEditPage from "./pages/InvoiceEditPage";
import InvoiceListPage from "./pages/InvoiceListPage";
import InvoicePreviewPage from "./pages/InvoicePreviewPage";
import LanguagePage from "./pages/LanguagePage";
import NotificationAlertPage from "./pages/NotificationAlertPage";
import NotificationPage from "./pages/NotificationPage";
import PaymentGatewayPage from "./pages/PaymentGatewayPage";
import PricingPage from "./pages/PricingPage";
import RoleAccessPage from "./pages/RoleAccessPage";
import SignInPage from "./pages/SignInPage";
import ThemePage from "./pages/ThemePage";
import UsersGridPage from "./pages/UsersGridPage";
import UsersListPage from "./pages/UsersListPage";
import ViewProfilePage from "./pages/ViewProfilePage";
import RouteScrollToTop from "./helper/RouteScrollToTop";
import AssignRolePage from "./pages/AssignRolePage";
import ComingSoonPage from "./pages/ComingSoonPage";
import MaintenancePage from "./pages/MaintenancePage";
import AccessDeniedPage from "./pages/AccessDeniedPage";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import TestimonialsPage from "./pages/TestimonialsPage";

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <RouteScrollToTop />
        <Routes>
          {/* Public Routes */}
          <Route exact path="/sign-in" element={<SignInPage />} />
          <Route
            exact
            path="/forgot-password"
            element={<ForgotPasswordPage />}
          />
          <Route exact path="/coming-soon" element={<ComingSoonPage />} />
          <Route exact path="/maintenance" element={<MaintenancePage />} />
          <Route exact path="/access-denied" element={<AccessDeniedPage />} />

          {/* Protected Routes for both Admin and Instructor */}
          <Route element={<ProtectedRoute roles={["ADMIN", "INSTRUCTOR"]} />}>
            {/* Dashboard */}
            <Route exact path="/" element={<HomePageSix />} />

            {/* Exam Management */}
            <Route exact path="/practice-mcqs" element={<PracticeMCQsPage />} />
            <Route exact path="/quiz-mcqs" element={<QuizMCQsPage />} />
            <Route exact path="/exam" element={<ExamPage />} />
            <Route exact path="/all-exams" element={<AllExamsPage />} />
            <Route
              exact
              path="/add-categories"
              element={<AddCategoriesPage />}
            />
            <Route exact path="/questions" element={<QuestionsPage />} />
            <Route exact path="/results" element={<ResultsPage />} />
            <Route exact path="/exam-results" element={<ExamResultsPage />} />
            <Route
              exact
              path="/exam-result-details"
              element={<ExamResultDetailsPage />}
            />

            {/* User Profile - accessible to both Admin and Instructor */}
            <Route exact path="/view-profile" element={<ViewProfilePage />} />
          </Route>

          {/* Admin-only Protected Routes */}
          <Route element={<ProtectedRoute roles={["ADMIN"]} />}>
            {/* Application Routes */}
            <Route exact path="/email" element={<EmailPage />} />
            <Route exact path="/chat-message" element={<ChatMessagePage />} />
            <Route exact path="/calendar-main" element={<CalendarMainPage />} />
            <Route exact path="/notifications" element={<NotificationPage />} />
            <Route exact path="/testimonials" element={<TestimonialsPage />} />

            {/* User Management */}
            <Route exact path="/users-list" element={<UsersListPage />} />
            <Route exact path="/users-grid" element={<UsersGridPage />} />
            <Route exact path="/add-user" element={<AddUserPage />} />

            {/* Role & Access */}
            <Route exact path="/role-access" element={<RoleAccessPage />} />
            <Route exact path="/assign-role" element={<AssignRolePage />} />

            {/* Pricing */}
            <Route exact path="/pricing" element={<PricingPage />} />

            {/* Settings */}
            <Route exact path="/company" element={<CompanyPage />} />
            <Route
              exact
              path="/notification-alert"
              element={<NotificationAlertPage />}
            />
            <Route exact path="/theme" element={<ThemePage />} />
            <Route exact path="/currencies" element={<CurrenciesPage />} />
            <Route exact path="/language" element={<LanguagePage />} />
            <Route
              exact
              path="/payment-gateway"
              element={<PaymentGatewayPage />}
            />

            {/* Invoice */}
            <Route exact path="/invoice-list" element={<InvoiceListPage />} />
            <Route
              exact
              path="/invoice-preview"
              element={<InvoicePreviewPage />}
            />
            <Route exact path="/invoice-add" element={<InvoiceAddPage />} />
            <Route exact path="/invoice-edit" element={<InvoiceEditPage />} />
          </Route>

          {/* Error Page */}
          <Route exact path="*" element={<ErrorPage />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
